// extracted by mini-css-extract-plugin
export var attribution = "_cw-4";
export var authorName = "_cw-5";
export var quote = "_cw-3";
export var testimonial = "_cw-2";
export var trustedBy = "_cw-0";
export var trustedByLabel = "_cw-1";